import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

export const addPrivateKeyDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

const cssPrefix = 'GetPrivateKeyFile';
export namespace AddKeyPairAuthDialogStyles {

  export const contentContainer = cssClass(cssPrefix, 'contentContainer', {
    display: 'flex',
  });

  export const innerContentContainer = cssClass(cssPrefix, 'inner-content-container', {
    flex: '1',
    minWidth: 0 // To contain text inside
  });

  export const fileSelectionContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    width: '100%', height: '34px',
    marginBottom: '6px',
    border: '0',
    position: 'relative'
  });

  export const fileName = cssClass(cssPrefix, 'file-name', {
    color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Typography.Color.PrimaryMedium),
  });

  export const fileNameField = cssClass(cssPrefix, 'file-name-field', {
    alignItems: 'left',
    width: '180px',
  });

  export const uploadPrivateKeyFileDescription = cssClass(cssPrefix, 'upload-private-key-description', {
    color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Typography.Color.PrimaryLight),
    lineHeight: `${TabStyles.Typography.Sizing.XLarge}px`
  });

  export const dialogStyle = cssClass(cssPrefix, 'add-private-key-dialog', {
    width: 'auto',
    height: 'auto',
    paddingTop: '18px',
    paddingBottom: '12px',
    paddingLeft: '12px',
    paddingRight: '12px'
  });
}
